import React from 'react';
import { ReactComponent as FlashCodeIcon } from '../../Icons/flashcode-icon_2.svg';
import './Auth.css';

function AuthPageBrandPanel() {
  return (
    <aside className="flashcode-auth-page__brand">
      <div className="flashcode-auth-page__brand-grid" aria-hidden />
      <div className="flashcode-auth-page__brand-glow" aria-hidden />
      <div className="flashcode-auth-page__logo">
        <span className="flashcode-auth-page__logo-mark" aria-hidden>
          <FlashCodeIcon />
        </span>
        <span className="flashcode-auth-page__logo-name">FlashCode</span>
      </div>

      <div className="flashcode-auth-page__hero">
        <div className="flashcode-auth-page__hero-copy">
          <strong className="flashcode-auth-page__hero-headline">
            Learn and remember
            <br />
            how to code.
          </strong>
          5 minutes a day.
          <br />
          Spaced repetition.
          <br />
          No excuses.
        </div>
      </div>

      <div className="flashcode-auth-page__tagline">Stop forgetting syntax.</div>
    </aside>
  );
}

export function AuthPageShell({ children }) {
  return (
    <div className="flashcode-auth-page">
      <div className="flashcode-auth-page__card flashcode-auth-page__fade-up">
        <AuthPageBrandPanel />
        <div className="flashcode-auth-page__form-column">
          <div className="flashcode-auth-page__form-grid" aria-hidden />
          <div className="flashcode-auth-page__form-inner">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default AuthPageShell;
